import { IReservation } from '../shared/interfaces/reservation.interfaces';
import { ApiService } from '../shared/services/api-service/api.service';
class EnhanceUpSellReservationServiceClass {

    async upSellReservation(hotelCode: number, reservation: IReservation,
        loyaltyTierId: number = null, currencyCode?: string, tcShareLocation?: boolean): Promise<IReservation> {
        const requestPayload = this._buildEnhanceUpSellReservationRequestPayload(reservation);
        try {
            const enhanceUpSellReservationApiResponse: Response = await ApiService.upSellReservation(hotelCode,
                requestPayload, loyaltyTierId, currencyCode, tcShareLocation);
            const enhanceUpSellReservationObject: IReservation = await enhanceUpSellReservationApiResponse.json();
            return enhanceUpSellReservationObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }

    private _buildEnhanceUpSellReservationRequestPayload(reservation: IReservation): IReservation {
        const payload: IReservation = JSON.parse(JSON.stringify(reservation));
        delete payload['hotelInfo'];
        delete payload['merchandisedPromoData'];
        delete payload['isPeStrikeThroughEnabled'];
        delete payload['merchandisedCurrencyExchgRate'];
        delete payload['isMerchandisedBooking'];
        delete payload['policies'];
        if (payload['roomStays'] && payload['roomStays'].length) {
            payload['roomStays'].forEach((roomStay) => {
                delete roomStay.total;
                delete roomStay.taxes;
                delete roomStay.prodTaxes;
                if (roomStay.roomRates && roomStay.roomRates.length) {
                    roomStay.roomRates.forEach((roomRate) => {
                        delete roomRate.rates;
                    });
                }
            });
        }
        return payload;
    }

}


export const UpSellReservationService = new EnhanceUpSellReservationServiceClass();
